import { __rest, __assign } from 'tslib';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { LoadingButton } from '@panwds/react-ui';

/**
 * A button to submit a form
 */
function SubmitButton(_a) {
    var _b = _a.children, children = _b === void 0 ? "Submit" : _b, passThrough = __rest(_a, ["children"]);
    var formState = useFormContext().formState;
    var isSubmitting = formState.isSubmitting, isSubmitSuccessful = formState.isSubmitSuccessful, isValid = formState.isValid;
    var _c = useState({
        loading: false,
        success: false
    }), dataResult = _c[0], setDataResult = _c[1];
    var onClickCallback = function () {
        setDataResult({
            loading: isSubmitting && isValid,
            success: isSubmitSuccessful
        });
    };
    return (React.createElement(LoadingButton, __assign({}, passThrough, { onClickCallback: onClickCallback, dataResult: dataResult, appearance: "primary", type: "submit" }), children));
}

export { SubmitButton };
//# sourceMappingURL=SubmitButton.esm.js.map
